export type SeriesPointCandidate = {
  seriesIndex: number;
  dataIndex: number;
  pointY: number;
};

export type NearestSeriesGroup = Array<{
  seriesIndex: number;
  dataIndex: number;
}>;

export function findNearestSeriesGroup(
  candidates: SeriesPointCandidate[],
  pointerY: number,
  groupingThreshold: number
): NearestSeriesGroup {
  const distanceToPointer = ({ pointY }: SeriesPointCandidate) => Math.abs(pointY - pointerY);
  // On a tie the earlier candidate wins.
  const nearest = candidates.reduce<SeriesPointCandidate | undefined>(
    (best, candidate) => (best && distanceToPointer(best) <= distanceToPointer(candidate) ? best : candidate),
    undefined
  );

  if (!nearest) {
    return [];
  }

  return candidates
    .filter(({ pointY }) => Math.abs(pointY - nearest.pointY) <= groupingThreshold)
    .map(({ seriesIndex, dataIndex }) => ({ seriesIndex, dataIndex }));
}
